import { Pipe, PipeTransform } from "@angular/core";
import { CollaboratorInvitation } from "@models/collaborator";
import { EventData } from "@models/event-data";
import { Page } from "@models/page";

@Pipe({
  name: "collaboratorToEventMapPipeTs",
  standalone: true,
})
export class CollaboratorToEventMapPipeTsPipe implements PipeTransform {
  transform(list: Page<CollaboratorInvitation> | null): Page<EventData> | null {
    if (!list) {
      return null;
    }

    const eventsPage = this.mapList(list);
    return eventsPage;
  }

  mapList(list: Page<CollaboratorInvitation>): Page<EventData> {
    const invitationsList = list.data;
    const eventList = invitationsList.map((invitation) => {
      const eventData = invitation.event;
      return eventData;
    });

    const mappedPage: Page<EventData> = {
      data: eventList,
      meta: list.meta,
    };
    return mappedPage;
  }
}
